
(function () {
  'use strict';

  /* ========================================
     CART COUNT
  ======================================== */

  function updateCartCount(count) {
    const value = Math.max(0, Number(count) || 0);

    document.querySelectorAll('[data-csa-cart-count]').forEach(function (badge) {
      badge.textContent = value;
      badge.hidden = value === 0;
    });
  }

  async function refreshCartCount() {
    try {
      const response = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        },
        credentials: 'same-origin'
      });

      if (!response.ok) return;

      const cart = await response.json();
      updateCartCount(cart.item_count);
    } catch (error) {
      // Cart count refresh failed; retain the existing count.
    }
  }

  /* ========================================
     HEADER & MOBILE DRAWER
     Sticky functionality disabled
  ======================================== */

  function initializeHeader(header) {
    if (header.dataset.csaInitialized === 'true') return;

    header.dataset.csaInitialized = 'true';

    const openButton = header.querySelector('[data-csa-open]');
    const closeButton = header.querySelector('[data-csa-close]');
    const overlay = header.querySelector('[data-csa-overlay]');
    const drawer = header.querySelector('[data-csa-drawer]');

    function openDrawer() {
      header.classList.add('is-drawer-open');

      openButton?.setAttribute('aria-expanded', 'true');
      drawer?.setAttribute('aria-hidden', 'false');

      document.documentElement.classList.add(
        'CSA-header-drawer-open'
      );
    }

    function closeDrawer(returnFocus) {
      header.classList.remove('is-drawer-open');

      openButton?.setAttribute('aria-expanded', 'false');
      drawer?.setAttribute('aria-hidden', 'true');

      document.documentElement.classList.remove(
        'CSA-header-drawer-open'
      );

      if (returnFocus && openButton) {
        openButton.focus();
      }
    }

    openButton?.addEventListener('click', openDrawer);

    closeButton?.addEventListener('click', function () {
      closeDrawer(true);
    });

    overlay?.addEventListener('click', function () {
      closeDrawer(true);
    });

    /* Mobile submenu toggles */

    drawer?.addEventListener('click', function (event) {
      const button = event.target.closest(
        '.CSA-header__submenu-toggle'
      );

      if (!button || !drawer.contains(button)) return;

      const heading = button.closest(
        '.CSA-header__drawer-item-head'
      );

      const submenu = heading?.nextElementSibling;

      if (
        !submenu ||
        !submenu.classList.contains(
          'CSA-header__drawer-submenu'
        )
      ) {
        return;
      }

      const expanded =
        button.getAttribute('aria-expanded') === 'true';

      button.setAttribute(
        'aria-expanded',
        String(!expanded)
      );

      submenu.hidden = expanded;
    });

    /* Close drawer when a navigation link is clicked */

    drawer?.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        closeDrawer(false);
      });
    });

    /* Close drawer with Escape */

    header.addEventListener('keydown', function (event) {
      if (
        event.key === 'Escape' &&
        header.classList.contains('is-drawer-open')
      ) {
        closeDrawer(true);
      }
    });
  }

  /*
   * STICKY HEADER DISABLED
   *
   * setupStickyHeader() intentionally removed.
   * No scroll listener, spacer, fixed positioning,
   * or automatic hide/show behaviour is installed.
   */

  /* ========================================
     INITIALIZE HEADERS
  ======================================== */

  function initializeAllHeaders(scope) {
    const root = scope || document;

    if (root.matches?.('[data-csa-header]')) {
      initializeHeader(root);
    }

    root.querySelectorAll?.('[data-csa-header]').forEach(
      function (header) {
        initializeHeader(header);
      }
    );
  }

  /* ========================================
     CART TRACKING
  ======================================== */

  function installCartTracking() {
    if (window.CSAHeaderCartTrackingInstalled) return;

    window.CSAHeaderCartTrackingInstalled = true;

    const originalFetch = window.fetch;

    window.fetch = function () {
      const args = arguments;
      const request = args[0];

      const requestUrl =
        typeof request === 'string'
          ? request
          : request && request.url
            ? request.url
            : '';

      const isCartMutation =
        /\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/i
          .test(requestUrl);

      const result = originalFetch.apply(this, args);

      if (!isCartMutation) {
        return result;
      }

      return result.then(function (response) {
        if (response.ok) {
          window.setTimeout(refreshCartCount, 100);
        }

        return response;
      });
    };

    /* Listen for cart update events */

    ['cart:updated', 'cart:change'].forEach(
      function (eventName) {
        document.addEventListener(eventName, function (event) {
          const count = event.detail?.item_count;

          if (count !== undefined) {
            updateCartCount(count);
          } else {
            refreshCartCount();
          }
        });
      }
    );

    /* Refresh count when the customer returns to the tab */

    document.addEventListener(
      'visibilitychange',
      function () {
        if (!document.hidden) {
          refreshCartCount();
        }
      }
    );
  }

  /* ========================================
     START
  ======================================== */

  function start() {
    initializeAllHeaders(document);
    installCartTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }

  /* Reinitialize after Shopify theme-editor section reloads */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeAllHeaders(event.target);
    }
  );
})();
